export enum GameTypeGamesCategoriesEnum {
  all = 'All',
  new = 'New games',
  live = 'Live Casino',
  slots = 'Slots',
  jackpots = 'Jackpots',
  blackjack = 'Blackjack',
  roulette = 'Roulette',
  classic = 'Table Games',
  megaways = 'Megaways',
  mustgojackpots = 'Must Go Jackpots',
  dropsandwins = 'Drops and Wins',
  fun = 'Scratch',
  mobileall = 'All',
  mobilenew = 'New games',
  mobilelive = 'Live Casino',
  mobileslots = 'Slots',
  mobilejackpots = 'Jackpots',
  mobileblackjack = 'Blackjack',
  mobileroulette = 'Roulette',
  mobileclassic = 'Table Games',
  mobilemegaways = 'Megaways',
  mobilefun = 'Scratch',
  mobilemustgojackpots = 'Must Go Jackpots',
  mobiledropsandwins = 'Drops and Wins',
}

export enum CategoriesPageTypeEnum {
  Categories = 'Categories',
  Provider = 'Provider',
  MyGames = 'My Games',
  Recommended = 'Recommended',
  Jackpots = 'Jackpots'
}

export enum FilterCategoriesOptions {
  Popular = "popular",
  AZ = "ascending",
  ZA = "descending"
}
